/* tslint:disable */
/* eslint-disable */
/**
 * Swagger LogisticProcess - OpenAPI 3.0
 * LogisticProcesses of the warehouse
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface CategoryResponse {
    'id': number;
    'name': string;
    'description': string;
}
export interface LogisticProcessRequest {
    'name': string;
    'description': string;
    'categoryId': number;
    'teamId': number;
    'dangerousProcess'?: boolean;
    'maxMinutesInversion'?: number;
}
export interface LogisticProcessResponse {
    'id'?: number;
    'name'?: string;
    'description'?: string;
    'dangerousProcess'?: boolean;
    'maxMinutesInversion'?: number;
    'category'?: CategoryResponse;
    'team'?: TeamResponse;
}
export interface LogisticProcessesResponseWithTotalHours {
    'totalHours'?: number;
    'id'?: number;
}
export interface TeamResponse {
    'id': number;
    'name': string;
    'description': string;
    'uuid'?: string;
    'sapStructureNumber'?: string;
}
export interface TotalHoursLogisticProcessByTeamResponse {
    'totalHours'?: number;
    'totalHoursPlanning'?: number;
    'collaborator'?: Array<LogisticProcessesResponseWithTotalHours>;
}

/**
 * LogisticProcessesApi - axios parameter creator
 */
export const LogisticProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new Logistic Process
         * @summary Create Logistic Process
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogisticProcess: async (logisticProcessRequest: LogisticProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticProcessRequest' is not null or undefined
            assertParamExists('createLogisticProcess', 'logisticProcessRequest', logisticProcessRequest)
            const localVarPath = `/v1/logistic_processes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete Logistic Processes
         * @summary Delete logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogisticProcess: async (logisticProcessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticProcessId' is not null or undefined
            assertParamExists('deleteLogisticProcess', 'logisticProcessId', logisticProcessId)
            const localVarPath = `/v1/logistic_processes/{logistic_process_id}`
                .replace(`{${"logistic_process_id"}}`, encodeURIComponent(String(logisticProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable Logistic Processes
         * @summary Enable logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLogisticProcess: async (logisticProcessId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticProcessId' is not null or undefined
            assertParamExists('enableLogisticProcess', 'logisticProcessId', logisticProcessId)
            const localVarPath = `/v1/logistic_processes/restore/{logistic_process_id}`
                .replace(`{${"logistic_process_id"}}`, encodeURIComponent(String(logisticProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all logistic processes by team
         * @summary Get All Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLogisticProcessesByTeam: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getAllLogisticProcessesByTeam', 'teamId', teamId)
            const localVarPath = `/v1/logistic_processes/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Deleted Logistic Processes
         * @summary Get Deleted Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticProcessesDeletedByTeam: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getLogisticProcessesDeletedByTeam', 'teamId', teamId)
            const localVarPath = `/v1/logistic_processes/deleted/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Total Hours of the logistic processes by Team
         * @summary Get Total Hours of the logistic processes by Team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursLogisticProcessesByTeam: async (startDate: string, endDate: string, teamId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getTotalHoursLogisticProcessesByTeam', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getTotalHoursLogisticProcessesByTeam', 'endDate', endDate)
            const localVarPath = `/v1/logistic_processes/totalHoursByTeam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Logistic Processes
         * @summary Update logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogisticProcess: async (logisticProcessId: number, logisticProcessRequest: LogisticProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticProcessId' is not null or undefined
            assertParamExists('updateLogisticProcess', 'logisticProcessId', logisticProcessId)
            // verify required parameter 'logisticProcessRequest' is not null or undefined
            assertParamExists('updateLogisticProcess', 'logisticProcessRequest', logisticProcessRequest)
            const localVarPath = `/v1/logistic_processes/{logistic_process_id}`
                .replace(`{${"logistic_process_id"}}`, encodeURIComponent(String(logisticProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogisticProcessesApi - functional programming interface
 */
export const LogisticProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogisticProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new Logistic Process
         * @summary Create Logistic Process
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLogisticProcess(logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLogisticProcess(logisticProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.createLogisticProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete Logistic Processes
         * @summary Delete logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLogisticProcess(logisticProcessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.deleteLogisticProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable Logistic Processes
         * @summary Enable logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableLogisticProcess(logisticProcessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.enableLogisticProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all logistic processes by team
         * @summary Get All Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLogisticProcessesByTeam(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogisticProcessResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLogisticProcessesByTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.getAllLogisticProcessesByTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Deleted Logistic Processes
         * @summary Get Deleted Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogisticProcessesDeletedByTeam(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LogisticProcessResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogisticProcessesDeletedByTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.getLogisticProcessesDeletedByTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Total Hours of the logistic processes by Team
         * @summary Get Total Hours of the logistic processes by Team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalHoursLogisticProcessesByTeam(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalHoursLogisticProcessByTeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalHoursLogisticProcessesByTeam(startDate, endDate, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.getTotalHoursLogisticProcessesByTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Logistic Processes
         * @summary Update logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLogisticProcess(logisticProcessId: number, logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogisticProcess(logisticProcessId, logisticProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticProcessesApi.updateLogisticProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogisticProcessesApi - factory interface
 */
export const LogisticProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogisticProcessesApiFp(configuration)
    return {
        /**
         * Create a new Logistic Process
         * @summary Create Logistic Process
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLogisticProcess(logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticProcessResponse> {
            return localVarFp.createLogisticProcess(logisticProcessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete Logistic Processes
         * @summary Delete logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig): AxiosPromise<LogisticProcessResponse> {
            return localVarFp.deleteLogisticProcess(logisticProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable Logistic Processes
         * @summary Enable logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig): AxiosPromise<LogisticProcessResponse> {
            return localVarFp.enableLogisticProcess(logisticProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all logistic processes by team
         * @summary Get All Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLogisticProcessesByTeam(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogisticProcessResponse>> {
            return localVarFp.getAllLogisticProcessesByTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Deleted Logistic Processes
         * @summary Get Deleted Logistic Processes
         * @param {number} teamId Id from team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticProcessesDeletedByTeam(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<LogisticProcessResponse>> {
            return localVarFp.getLogisticProcessesDeletedByTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Total Hours of the logistic processes by Team
         * @summary Get Total Hours of the logistic processes by Team
         * @param {string} startDate Start date
         * @param {string} endDate End date
         * @param {number} [teamId] Id team
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalHoursLogisticProcessesByTeam(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig): AxiosPromise<TotalHoursLogisticProcessByTeamResponse> {
            return localVarFp.getTotalHoursLogisticProcessesByTeam(startDate, endDate, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Logistic Processes
         * @summary Update logistic Process
         * @param {number} logisticProcessId Id from logisticProcess
         * @param {LogisticProcessRequest} logisticProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogisticProcess(logisticProcessId: number, logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticProcessResponse> {
            return localVarFp.updateLogisticProcess(logisticProcessId, logisticProcessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogisticProcessesApi - object-oriented interface
 */
export class LogisticProcessesApi extends BaseAPI {
    /**
     * Create a new Logistic Process
     * @summary Create Logistic Process
     * @param {LogisticProcessRequest} logisticProcessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLogisticProcess(logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).createLogisticProcess(logisticProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete Logistic Processes
     * @summary Delete logistic Process
     * @param {number} logisticProcessId Id from logisticProcess
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).deleteLogisticProcess(logisticProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable Logistic Processes
     * @summary Enable logistic Process
     * @param {number} logisticProcessId Id from logisticProcess
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enableLogisticProcess(logisticProcessId: number, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).enableLogisticProcess(logisticProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all logistic processes by team
     * @summary Get All Logistic Processes
     * @param {number} teamId Id from team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllLogisticProcessesByTeam(teamId: number, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).getAllLogisticProcessesByTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Deleted Logistic Processes
     * @summary Get Deleted Logistic Processes
     * @param {number} teamId Id from team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLogisticProcessesDeletedByTeam(teamId: number, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).getLogisticProcessesDeletedByTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Total Hours of the logistic processes by Team
     * @summary Get Total Hours of the logistic processes by Team
     * @param {string} startDate Start date
     * @param {string} endDate End date
     * @param {number} [teamId] Id team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotalHoursLogisticProcessesByTeam(startDate: string, endDate: string, teamId?: number, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).getTotalHoursLogisticProcessesByTeam(startDate, endDate, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Logistic Processes
     * @summary Update logistic Process
     * @param {number} logisticProcessId Id from logisticProcess
     * @param {LogisticProcessRequest} logisticProcessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLogisticProcess(logisticProcessId: number, logisticProcessRequest: LogisticProcessRequest, options?: RawAxiosRequestConfig) {
        return LogisticProcessesApiFp(this.configuration).updateLogisticProcess(logisticProcessId, logisticProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



